import { render, staticRenderFns } from "./create-periodic-payment.vue?vue&type=template&id=00a72e44&scoped=true"
import script from "./create-periodic-payment.vue?vue&type=script&lang=js"
export * from "./create-periodic-payment.vue?vue&type=script&lang=js"
import style0 from "./create-periodic-payment.vue?vue&type=style&index=0&id=00a72e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a72e44",
  null
  
)

export default component.exports